import { isNullOrEmptyArray } from "src/util/arrays";

/**
 * @param {array} oldSurveyList Antigo array de perguntas selecionadas. 
 * @param {array} newSurveyList Novo array de perguntas selecionadas.
 * @returns {array} Diferença entre os dois arrays (A - B)
 */
export const getSurveyListDifference = function(oldSurveyList = [], newSurveyList = []) {
  const difference = oldSurveyList.filter(({ id }) => !newSurveyList.some(({ id: newId }) => id === newId))
  return difference;
}

export const getIdListHasDuplicates = function(idList = []) {
  return (new Set(idList)).size !== idList.length;
}